import React, { useEffect } from "react";
import "./OrderPlacedSuccessfullModal.css";
import { Button, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import Successfull_Lottie from "../../../animation/successfull_lottie/Successfull_Lottie";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import White_Btn from "../../common_btn/white_btn/White_Btn";
import { IDS } from "../../../../utils/IDS";

function OrderPlacedSuccessfullModal({ paymentData, baseLink, ...props }) {

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (props.onHide) {
  //       props.onHide(); 
  //     }
  //   }, 5000);

  //   return () => clearTimeout(timer); 
  // }, [props]);

  const navigate = useNavigate()

  return (
    <>
      <section className="OrderPlacedSuccessfullModal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="OrderPlacedSuccessfullModal modal-holder"
        >
          <Modal.Body>
            <div className="success_main_div">
              <div className="celebrate_lottie_holder">
                {/* <Celebrate_Lottie /> */}
              </div>
              <div className="success_loottie_holder">
                <Successfull_Lottie />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">Order Placed Successfully</p>

                  <p className="sub_text">
                    Order placed successfully your product will be
                    <br /> delivered soon.{" "}
                  </p>
                </div>
              </div>

              <div className="text-center btn_holder">
                <div className="home_btn">
                  <White_Btn btnText="Go to Home" onClick={() => { navigate("/home") }} />
                </div>
                <div className="continue_btn">
                  <Pink_Btn btnText="Continue Shopping" onClick={() => { navigate("/explore-latest-products") }} />
                </div>
              </div>

              <div className="track_order_div">
                <div className="left_side_div">
                  <div className="img_holder">
                    {paymentData?.order_Details_summary?.length > 0 ? (
                      <img
                        src={IDS.IMG_URL + paymentData.order_Details_summary[0]?.product_image}
                        alt="product"
                      />
                    ) : (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/explore/top-products/product2.png"
                        }
                        alt="default"
                      />
                    )
                    }
                  </div>

                  <div className="text_holder">
                    <div className="title">
                      <p>Track Your Order</p>
                    </div>
                    <div className="footer_text">
                      <p>Rider will be assigned soon</p>
                    </div>
                  </div>
                </div>

                <div className="right_side">
                  <div className="text-center btn_holder">
                    <Light_Black_Btn btnText="View Details" onClick={() => { navigate(baseLink) }} />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default OrderPlacedSuccessfullModal;
